<template>
  <div class="admin-categories">
    <header-title title="Zona de Mesas QR"></header-title>

    <div class="category-btn">
      <v-btn
        dense
        outlined
        @click="openZoneTableDialog('addZone')"
        :style="adminNavigationBackTheme"
      >
        + Nueva Zona
      </v-btn>
    </div>

    <v-container fluid class="pl-0 pr-0">
      <v-row justify="center">
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-text-field
            dense
            outlined
            v-model="search"
            label="Buscar Zona"
            class="select-box"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            dense
            outlined
            class="select-box"
            v-model="acceptDirectPaymentSelected"
            :items="acceptDirectPaymentOptions"
            item-text="label"
            item-value="value"
            label="Acepta Pago Directo"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2">
          <v-select
            dense
            outlined
            class="select-box"
            v-model="selectedMenus"
            :items="menus"
            label="Cartas"
            item-text="name"
            item-value="id"
            multiple
          >
          </v-select>
        </v-col>
        <v-col cols="12" justify="center" sm="6" md="3" lg="2">
          <v-btn
            dense
            outlined
            @click="resetFilters"
            :style="adminResetFiltersTheme"
          >
            Borrar Filtros
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="zones"
          class="elevation-1 payments-table"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.selectedMenu`]="{ item }">
            <div style="display:flex;">
              {{ showMenuNames(item.selectedMenu) }}
            </div>
          </template>
          <template v-slot:[`item.active`]="{ item }">
            <div style="display:flex;">
              <v-switch
                v-model="item.active"
                @change="markOneZoneActive($event, item)"
              ></v-switch>
            </div>
          </template>
          <template v-slot:[`item.acceptDirectPayment`]="{ item }">
            <div style="display:flex;">
              <v-switch
                :disabled="disableDirectPaymentSwitch"
                v-model="item.acceptDirectPayment"
                @change="markOneZonePaymentDirect($event, item)"
              ></v-switch>
            </div>
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <v-icon small class="mr-2" @click="openZoneTableDialog(item.id)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <ZoneTablesDialog
      ref="zoneTableDialog"
      :disableDirectPaymentSwitch="disableDirectPaymentSwitch"
    ></ZoneTablesDialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
let fromRoute = undefined;
import ZoneTablesDialog from "../../../components/admin/qr/ZoneTablesDialog";
import { intersection } from "lodash";
import HeaderTitle from "@/components/admin/common/HeaderTitle.vue";
import { ZonaTablesQRTableHeader } from "@/utils/tableHeaderconstants";
import { qrZoneCollection, updateQrZone } from "@/collections/qrZone";
import { getQRsByZone, updateQR } from "@/collections/qrs";
import { menusCollection } from "@/collections/menus";
import { menuGroupCollection } from "@/collections/menuGroup";

export default {
  name: "zone-tables-qr",
  components: {
    ZoneTablesDialog,
    HeaderTitle
  },
  data() {
    return {
      zoneTablesQRCollection: [],
      search: "",
      headers: [...ZonaTablesQRTableHeader],
      acceptDirectPaymentSelected: "",
      acceptDirectPaymentOptions: [
        {
          label: "Si",
          value: true
        },
        {
          label: "No",
          value: false
        }
      ],
      menusCollection: [],
      menuGroupCollection: [],
      selectedMenus: []
    };
  },
  firestore() {
    return {
      zoneTablesQRCollection: qrZoneCollection,
      menusCollection: menusCollection.where("active", "==", true),
      menuGroupCollection: menuGroupCollection.where("active", "==", true)
    };
  },
  computed: {
    zones() {
      if (
        this.search !== "" ||
        this.acceptDirectPaymentSelected !== "" ||
        (this.selectedMenus && this.selectedMenus.length > 0)
      ) {
        let search =
          this.acceptDirectPaymentSelected !== "" && this.search === ""
            ? this.zoneTablesQRCollection
            : this.zoneTablesQRCollection.filter(zone => {
                return zone.name
                  .toLowerCase()
                  .includes(this.search.toLowerCase());
              });

        if (this.acceptDirectPaymentSelected !== "") {
          search = search.filter(
            zone =>
              this.acceptDirectPaymentSelected === zone.acceptDirectPayment
          );
        }
        if (this.selectedMenus && this.selectedMenus.length > 0) {
          search = search.filter(item => {
            let intersectValue = intersection(
              this.selectedMenus,
              item.selectedMenu
            );
            if (intersectValue && intersectValue.length > 0) {
              return item;
            }
          });
        }

        return search;
      }
      return this.zoneTablesQRCollection;
    },
    disableDirectPaymentSwitch() {
      return !!(
        this.settings &&
        this.settings.paymentMethod &&
        this.settings.paymentMethod === "nomobilepayment"
      );
    },
    menus() {
      let cloneMenus = JSON.parse(JSON.stringify(this.menusCollection));
      let cloneMenuGroup = JSON.parse(JSON.stringify(this.menuGroupCollection));

      let defautOptionArray = [
        {
          name: "Todas",
          id: "all"
        },
        {
          name: "Comidas",
          id: process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID
        },
        {
          name: "Bebidas",
          id: process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID
        },
        {
          name: "Postres",
          id: process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID
        }
      ];
      cloneMenus = [...defautOptionArray, ...cloneMenus, ...cloneMenuGroup];
      return cloneMenus;
    }
  },
  methods: {
    showMenuNames(selectedMenu) {
      let array = [];

      let foundAll = selectedMenu.some(item => {
        if (item === "all") {
          return item;
        }
      });

      if (foundAll) {
        return "Todas";
      }

      let foundDrins = selectedMenu.some(item => {
        if (item === process.env.VUE_APP_PRODUCT_TYPE_DRINKS_ID) {
          return item;
        }
      });
      if (foundDrins) {
        array.push("Bebida");
      }

      let foundFood = selectedMenu.some(item => {
        if (item === process.env.VUE_APP_PRODUCT_TYPE_FOOD_ID) {
          return item;
        }
      });
      if (foundFood) {
        array.push("Comida");
      }

      let foundDessert = selectedMenu.some(item => {
        if (item === process.env.VUE_APP_PRODUCT_TYPE_DESSERT_ID) {
          return item;
        }
      });
      if (foundDessert) {
        array.push("Postre");
      }

      this.menusCollection.forEach(item => {
        let foundMenu = selectedMenu.some(menu => {
          if (menu === item.id) {
            return menu;
          }
        });

        if (foundMenu) {
          array.push(item.name);
        }
      });

      this.menuGroupCollection.forEach(item => {
        let foundMenuGroup = selectedMenu.some(menuGroup => {
          if (menuGroup === item.id) {
            return menuGroup;
          }
        });
        if (foundMenuGroup) {
          array.push(item.name);
        }
      });

      return array.join();
    },
    resetFilters() {
      this.acceptDirectPaymentSelected = "";
      this.search = "";
      this.selectedMenus = [];
    },
    async markOneZonePaymentDirect(value, zone) {
      try {
        await updateQrZone(zone.id, { acceptDirectPayment: value });
      } catch (error) {
        this.setlogError(
          "update_qr_zone",
          "Obtained error message in markOneZonePaymentDirect()",
          error.stack,
          this.$options.name
        );
      }
    },
    async markOneZoneActive(value, zone) {
      try {
        await updateQrZone(zone.id, { active: value });
        let qrsByZone = await getQRsByZone(zone.id);
        qrsByZone.forEach(async doc => {
          try {
            await updateQR(doc.id);
          } catch (error) {
            // eslint-disable-next-line
            this.setlogError(
              "update_QR",
              "Obtained error message in markOneZoneActive()",
              error.stack,
              this.$options.name
            );
          }
        });
      } catch (error) {
        // eslint-disable-next-line
        this.setlogError(
          "update/qr_zone/qr",
          "Obtained error message in markOneZoneActive()",
          error.stack,
          this.$options.name
        );
      }
    },
    openZoneTableDialog(itemId) {
      this.$refs.zoneTableDialog.open(itemId);
    }
  },
  mounted() {
    setTimeout(() => {}, 2000);
  },
  beforeRouteEnter(to, from, next) {
    fromRoute = from;
    next();
  }
};
</script>

<style>
.table-scroll {
  max-width: 100%;
  overflow-x: auto;
}
@media screen and (max-width: 767px) {
  .tabs-stage .header-table .header-quantity,
  .tabs-stage .gfg .value-quantity {
    width: 200px !important;
  }
}
</style>
